import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import helpEmails from 'assets/img/helpEmails.png';
import { Creators as AuthCreators } from 'store/ducks/auth';
import Section from 'components/Section';
import OutsideClickHandler from 'react-outside-click-handler';
import { Switch, Spinner } from 'triider-components';
import {
  Container,
  TitlePage,
  ContainerPassword,
  ContentProfile,
  ContainerUser,
  ContentProfileUser,
  ImageUser,
  EditImage,
  ContentUserName,
  FormStyled,
  ContentFields,
  RowFields,
  Label,
  Input,
  ReceiveEmails,
  ImgStyled,
  BtnSubmit,
  Tooltip,
} from './styles';

function ManageUser({
  isLoading, user, _updateTriiderUser, _forgotPasswordSendEmail,
}) {
  const [name, setName] = useState(user.name);
  const [email, setEmail] = useState(user.email);
  const [phone, setPhone] = useState(user.phone);
  const [city, setCity] = useState(user.city_name);
  const [profilePicture, setProfilePicture] = useState(user.profile_picture);
  const [filePhoto, setFilePhoto] = useState(null);
  const [receivesEmails, setReceivesEmails] = useState(user.receives_emails);
  const [isOpenTooltip, setIsOpenTooltip] = useState(false);

  const [isDisabled, setIsDisabled] = useState(false);

  useEffect(() => {
    if (
      name !== user.name
      || email !== user.email
      || phone !== user.phone
      || city !== user.city_name
      || receivesEmails !== user.receives_emails
      || profilePicture !== user.profile_picture
    ) {
      setIsDisabled(false);
    } else {
      setIsDisabled(true);
    }
  }, [name, email, phone, city, receivesEmails, profilePicture, isLoading]);

  const handleSubmit = (event) => {
    event.preventDefault();
    _updateTriiderUser({
      fields: {
        name,
        email,
        phone,
        city_name: city,
        receives_emails: receivesEmails,
        profile_picture: profilePicture,
        filePhoto,
      },
    });
  };

  const handleResetPassword = () => {
    _forgotPasswordSendEmail({ email: user.email, isManageUser: true });
  };

  const handleChangeFile = async (event) => {
    const fileUser = event.target.files[0];
    if (fileUser) {
      setFilePhoto(fileUser);
      setProfilePicture(URL.createObjectURL(fileUser));
    }
  };

  return (
    <Section color="#FBFBFB" flexColumn>
      <TitlePage>Gerenciar perfil</TitlePage>
      <Container>
        <ContainerUser>
          <ContentProfile>
            <ContentProfileUser>
              <ImageUser src={profilePicture || `https://ui-avatars.com/api/?background=FF8800&color=fff&name=${user.name && user.name.replace(' ', '%20')}`} />
              <EditImage>
                <input type="file" accept="image/*" onChange={e => handleChangeFile(e)} />
              </EditImage>
            </ContentProfileUser>
            <ContentUserName>
              <h2>{user.name}</h2>
              <p>{user.email}</p>
            </ContentUserName>
          </ContentProfile>
          {isLoading ? (
            <Spinner size="larger" />
          ) : (
            <FormStyled onSubmit={handleSubmit}>
              <RowFields>
                <ContentFields width="50%">
                  <Label>Nome:</Label>
                  <Input type="text" value={name} onChange={e => setName(e.target.value)} />
                </ContentFields>
                <ContentFields width="50%">
                  <Label>Email:</Label>
                  <Input type="email" value={email} onChange={e => setEmail(e.target.value)} />
                </ContentFields>
              </RowFields>
              <RowFields>
                <ContentFields width="50%">
                  <Label>Telefone:</Label>
                  <Input type="text" value={phone} onChange={e => setPhone(e.target.value)} />
                </ContentFields>
                <ContentFields width="50%">
                  <Label>Cidade:</Label>
                  <Input type="text" value={city} onChange={e => setCity(e.target.value)} />
                </ContentFields>
              </RowFields>
              <RowFields>
                <ReceiveEmails>Deseja receber e-mails</ReceiveEmails>
                <ImgStyled src={helpEmails} onClick={() => setIsOpenTooltip(!isOpenTooltip)} alt="Ícone de ajuda" />
                <OutsideClickHandler onOutsideClick={() => setIsOpenTooltip(false)}>
                  <Tooltip open={isOpenTooltip}>
                    <span />
                    Permite que o usuário receba e-mails referente à situação dos pedidos administrados por ele
                  </Tooltip>
                </OutsideClickHandler>
                <Switch
                  value={receivesEmails}
                  checked={receivesEmails}
                  onChange={() => setReceivesEmails(!receivesEmails)}
                />
              </RowFields>
              <BtnSubmit type="submit" disabled={isDisabled}>
                Salvar alterações
              </BtnSubmit>
            </FormStyled>
          )}
        </ContainerUser>
        <ContainerPassword>
          <TitlePage fontSize="20px">Alterar Senha</TitlePage>
          <div>
            <p>Você receberá um e-mail contendo as instruções para redefinir sua senha</p>
            <p>
              <span onClick={() => handleResetPassword()}>Enviar e-mail de redefinição de senha</span>
            </p>
          </div>
        </ContainerPassword>
      </Container>
    </Section>
  );
}

const mapStateToProps = state => ({
  isLoading: state.ui.loaders.includes('UPDATE_USER'),
  user: state.auth.triiderUser.user,
});

const mapDispatchToProps = {
  _updateTriiderUser: AuthCreators.updateTriiderUserRequest,
  _forgotPasswordSendEmail: AuthCreators.forgotPasswordSendEmailrequest,
};

export default connect(mapStateToProps, mapDispatchToProps)(ManageUser);
